import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { useEffectOnce } from 'usehooks-ts';

/**
 * Crea un Subject per coordinare il rerendering dei portali:
 * siamo infatti costretti a dover forzare il re-rendering del contenuto **se
 * il portale viene smontato e rimontato** (ad esempio a causa di un cambio di
 * container).
 */
export function createPortalSubject() {
  const portalSubject = new Subject<{ type: 'rendered' }>();

  const useTrigger = () => {
    useEffectOnce(() => {
      portalSubject.next({ type: 'rendered' });
    });
  };

  const useRerenderCount = () => {
    const [rerenderCount, setRerenderCount] = useState(0);

    useEffect(() => {
      const unsubscribe = portalSubject.subscribe(event => {
        if (event.type === 'rendered') {
          setRerenderCount(count => count + 1);
        }
      });

      return () => {
        unsubscribe.unsubscribe();
      };
    }, []);

    return rerenderCount;
  };

  return { useTrigger, useRerenderCount };
}
